import type { SVGProps } from "react";

export default function FunctionalityIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.0003 18.3335C14.6027 18.3335 18.3337 14.6025 18.3337 10.0002C18.3337 5.39778 14.6027 1.66682 10.0003 1.66682C5.39795 1.66682 1.66699 5.39778 1.66699 10.0002C1.66699 14.6025 5.39795 18.3335 10.0003 18.3335Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M10 5.83363V10.8336"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M10.0003 14.1668C10.4606 14.1668 10.8337 13.7937 10.8337 13.3334C10.8337 12.8732 10.4606 12.5001 10.0003 12.5001C9.54009 12.5001 9.16699 12.8732 9.16699 13.3334C9.16699 13.7937 9.54009 14.1668 10.0003 14.1668Z"
        fill="currentColor"
      />
    </svg>
  );
}
